export const customGa = (category = "", action = "", label = "", value = 0, sendAjax = false) => {
    if(window.isErrorPage) return;

    if(sendAjax) registerEventServer(category, action);

    // noinspection JSUnresolvedReference
    if(!window.ga) return;

    window.ga('send', 'event', category, action, label, value);
};
window.customGa = customGa;

export const customPageViewGa = (category = "") => {
    if(window.isErrorPage) return;

    // noinspection JSUnresolvedReference
    if(!window.ga) return;
    window.ga('send', 'pageview', category);
};

// noinspection JSUnusedLocalSymbols
const customDataLayerPush = (obj = {}) => {
    if(window.isErrorPage) return;

    // noinspection JSUnresolvedReference
    if(!window.dataLayer) return;

    window.dataLayer.push(obj);
};

function registerEventServer(category, action) {
  const formData = new FormData();
  formData.append('category', category);
  formData.append('step', action);
  fetch(window.HTML_ROOT + '/register-funnel', {
    method: 'POST',
    headers: {'X-Requested-With': 'XMLHttpRequest'},
    body: formData
  }).then();
}

// noinspection JSUnusedLocalSymbols
export function customGaSetDimension(key = "", value = "") {
    if(window.isErrorPage) return;

    // noinspection JSUnresolvedReference
    if(!window.ga) return;

    window.localStorage.setItem(key, value);

    window.ga('set', key, value);
    // noinspection JSUnresolvedReference
    window.ga('send', 'pageview');
}